import { DelayedExecution } from '@/admin/shared/helpers/delayed-execution';
import { ICandidate } from '@/shared/api-client/models/candidate';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { StringComparer } from '@/shared/helpers/string-comparer';
import { ICandidateFilterSetting } from '@/shared/Models/candidate-filter-setting';
import _ from 'lodash';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

export interface ICandidateFilterResult {

    query: string;

    aggregations: ICandidateFilterAggregation[];
}

export interface ICandidateFilterAggregation {

    propertyName: string;

    values: string[];
}

interface IViewModel {

    isLoaded: boolean;
}

interface IFormDataModel {

    query: string
}

@Component
export default class CandidateElectionFilterComponent extends Vue {

    @Prop({default: false}) public enableFullTextSearch!: boolean;
    @Prop() public filters!: ICandidateFilterSetting[];
    @Prop() public translations!: { [key: string]: string; };
    @Prop() public candidates!: ICandidate[];

    @Emit()
    public filterChanged(): ICandidateFilterResult {
        return this.filter;
    }

    public get isFiltered(): boolean {

        if (!this.filter) {
            return false;
        }

        return (this.filter.query !== '' || this.filter.aggregations.length > 0);
    }

    private delayedExecution = new DelayedExecution(1000);

    public filter: ICandidateFilterResult = {
        query: '',
        aggregations: []
    }

    public viewModel: IViewModel = {
        isLoaded: false
    };

    public formData: IFormDataModel = {
        query: ''
    }

    constructor() {
        super();
    }

    public reset($event?: UIEvent): void {

        if ($event) {

            $event.preventDefault();
        }

        this.filter = {
            query: '',
            aggregations: []
        };

        this.formData.query = '';

        this.filterChanged();
    }

    public toogleAggregation(propertyName: string, value: string, $event?: UIEvent): void {

        ArgumentValidator.notNullOrEmpty(propertyName, `propertyName`);
        ArgumentValidator.notNullOrEmpty(value, `value`);

        if ($event) {

            $event.preventDefault();
        }

        let currentBucket = this.filter.aggregations?.find(x => x.propertyName.toLowerCase() === propertyName.toLowerCase());

        if (!currentBucket) {

            currentBucket = {
                propertyName,
                values: [value]
            }

            this.filter.aggregations.push(currentBucket);

        } else {

            if (currentBucket.values.includes(value)) {

                currentBucket.values = currentBucket.values.filter(x => x !== value);
            } else {

                currentBucket.values.push(value);
            }
        }

        if (!currentBucket.values || currentBucket.values.length <= 0) {

            this.filter.aggregations = this.filter.aggregations.filter(x => x.propertyName !== propertyName);
        }

        this.filterChanged();
    }

    public countAggregations(propertyName: string): number {

        ArgumentValidator.notNullOrEmpty(propertyName, `propertyName`);

        const currentBucket = this.filter.aggregations?.find(x => x.propertyName.toLowerCase() === propertyName.toLowerCase());

        if(!currentBucket || currentBucket.values.length <= 0) {
            return 0;
        }

        return currentBucket.values.length;
    }

    public isSelected(propertyName: string, value: string): boolean {

        ArgumentValidator.notNullOrEmpty(propertyName, `propertyName`);
        ArgumentValidator.notNullOrEmpty(value, `value`);

        const currentBucket = this.filter.aggregations?.find(x => x.propertyName.toLowerCase() === propertyName.toLowerCase());

        return (!!currentBucket && currentBucket.values.includes(value));
    }

    public aggregatedValues(propertyName: string): string[] {

        ArgumentValidator.notNullOrEmpty(propertyName, `propertyName`);

        let filterAggregations: string[] = [];

        this.candidates.forEach(x => {

            if (x.filterableProperties) {

                const filterValue = x.filterableProperties[propertyName.toLowerCase()];

                if (filterValue && filterAggregations.findIndex(y => StringComparer.compare(y, filterValue)) === -1) {
                    filterAggregations.push(filterValue);
                }
            }
        });

        filterAggregations = filterAggregations.sort();

        return filterAggregations;
    }

    public hasAggregatedValues(propertyName: string): boolean {

        return this.aggregatedValues(propertyName).length > 0;
    }

    public queryChanged(query: string, event?: KeyboardEvent): void {

        this.delayedExecution.execute(() => {

            this.filter.query = query.trim();

            this.filterChanged();
        });
    }
}
